<template>
  <v-container fluid>
    <div></div>
    <v-tab-item class="pb-0" eager>
      <div class="display-1 font-weight-normal mb-2 text-center">Selecione o mês que será apagado</div>
      <v-alert v-if="versaoContextoBloqueada" dense outlined type="warning" color="warning" class="mb-4">
        Você está trabalhando na BDGD
        {{ versaoContextoBloqueada.data_registro | formatToMonth }} v{{ versaoContextoBloqueada.versao }}, mas não tem permissão
        para editar os dados dessa versão — por isso ela não aparece para seleção aqui. Escolha outra versão da BDGD para
        continuar.
      </v-alert>
      <first-tab-content
        :itemsTable="itemsTableFirstTab"
        :selectedItem.sync="selectedItemFirstTab"
        :loading.sync="loadingFirstTab"
        @stepReleased="$emit('step-observer', { step: 0, complete: $event })"
      />
    </v-tab-item>
    <v-tab-item class="pb-0" eager>
      <div class="display-1 font-weight-normal mb-6 text-center">Selecione as entidades que serão apagadas</div>
      <second-tab-content
        :itemsTable="itemsTableSecondTab"
        :selectedItem.sync="selectedItemSecondTab"
        :loading.sync="loadingSecondTab"
        @stepReleased="
          ($emit('step-observer', { step: 1, complete: $event }), $emit('step-observer', { step: 2, complete: $event }))
        "
      />
    </v-tab-item>
    <v-tab-item class="pb-0" eager>
      <third-tab-content :records="totalRecordsThirdTab" @arquivarBdgdAlterado="(e) => atualizaFlagArquivarBdgd(e)" />
    </v-tab-item>
  </v-container>
</template>

<script>
  import ExpurgosService from '@/services/ExpurgosService';

  export default {
    components: {
      FirstTabContent: () => import('@/components/dados/expurgo-bdgd/tabs/FirstTabContent.vue'),
      SecondTabContent: () => import('@/components/dados/expurgo-bdgd/tabs/SecondTabContent.vue'),
      ThirdTabContent: () => import('@/components/dados/expurgo-bdgd/tabs/ThirdTabContent.vue')
    },
    props: {
      items: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        loadingFirstTab: false,
        loadingSecondTab: false,
        itemsTableFirstTab: [],
        itemsTableSecondTab: [],
        arquivarBdgd: false,
        selectedItemFirstTab: [],
        selectedItemSecondTab: [],
        totalRecordsThirdTab: 0,
        versaoContextoBloqueada: null
      };
    },
    computed: {
      userSelectedCompanyBdgdVersion() {
        return this.$store.getters.getUserSelectedCompanyBdgdVersion;
      }
    },
    created() {
      this.fillFirstTab();
    },
    methods: {
      fillFirstTab() {
        this.loadingFirstTab = true;
        ExpurgosService.getDatesAndRegistersImportedEntities()
          .then((response) => {
            const versaoContexto = this.userSelectedCompanyBdgdVersion;
            this.versaoContextoBloqueada =
              (versaoContexto &&
                response.data.find(
                  (item) => Number(item.bdgd_versao_id) === Number(versaoContexto.id) && item.bloqueada_para_usuario_atual
                )) ||
              null;

            this.itemsTableFirstTab = response.data.filter((item) => !item.bloqueada_para_usuario_atual);
            const selectedBdgdVersion = this.itemsTableFirstTab.filter(
              (item) => !!versaoContexto && item.bdgd_versao_id === versaoContexto.id
            );
            this.selectedItemFirstTab = selectedBdgdVersion;
          })
          .finally(() => (this.loadingFirstTab = false));
      },
      fillSecondTab(selectedDate, companyId, bdgdVersionId) {
        this.loadingSecondTab = true;
        ExpurgosService.getImportedEntitiesAndRegistersByDate(selectedDate, companyId, bdgdVersionId)
          .then((response) => (this.itemsTableSecondTab = response.data))
          .catch(() => this.$emit('stepReleased', { numberStep: 1, available: false }))
          .finally(() => (this.loadingSecondTab = false));
      },
      exportData() {
        let arrTabelas = [];
        this.selectedItemSecondTab.forEach((item) => {
          arrTabelas.push(item.entidade);
        });
        return {
          tabelas: JSON.stringify(arrTabelas),
          data_registro: this.selectedItemFirstTab[0].data_registro,
          company_id: this.selectedItemFirstTab[0].empresa_id,
          bdgd_versao_id: this.selectedItemFirstTab[0].bdgd_versao_id,
          numero_linhas: this.totalRecordsThirdTab,
          arquivar_bdgd: this.arquivarBdgd,
          usuario_id: this.$store.getters.getUserId,
          status: 'AGUARDANDO'
        };
      },
      atualizaFlagArquivarBdgd(bool) {
        this.arquivarBdgd = bool;
      }
    },
    watch: {
      selectedItemFirstTab(arrNewVal) {
        let selectedDate = arrNewVal.length ? arrNewVal[0].data_registro : undefined;
        let companyId = arrNewVal.length ? arrNewVal[0].empresa_id : undefined;
        let bdgdVersionId = arrNewVal.length ? arrNewVal[0].bdgd_versao_id : undefined;
        if (selectedDate && companyId && bdgdVersionId) {
          this.fillSecondTab(selectedDate, companyId, bdgdVersionId);
        }
      },
      selectedItemSecondTab(arrNewVal) {
        let totalRecords = 0;
        if (arrNewVal.length) {
          totalRecords = arrNewVal.map((item) => item.registros).reduce((prev, next) => prev + next);
        }
        this.totalRecordsThirdTab = totalRecords;
      }
    }
  };
</script>
